<template>
    <div class="exception-view">
        <div class="detail-view">
            <el-descriptions title="产品已下架" extra="如有需要，请联系企业" :column="3">
                <el-descriptions-item label="产品名称" :span="3">{{ productDetail.ProdName }}</el-descriptions-item>
                <el-descriptions-item label="企业名称" :span="3">{{ productDetail.CompName }}</el-descriptions-item>
                <el-descriptions-item label="企业通号">{{ productDetail.CompMdt }}</el-descriptions-item>
                <el-descriptions-item label="浏览数">{{ productDetail.ViewNums }}</el-descriptions-item>
                <el-descriptions-item label="下载数">{{ productDetail.DownNums }}</el-descriptions-item>
                <el-descriptions-item
                    :label="item.CSName || item.NickName"
                    v-for="(item, index) in customerList"
                    :key="index"
                >{{ item.Phone }}</el-descriptions-item>
            </el-descriptions>
        </div>
        
        <el-card class="box-card" header="同类产品推荐" v-loading="loading">
            <div class="recommed-view">
                <div class="prod-list-block" v-for="prod in prods" :key="prod.ProdID">
                <card-list :data="prod" type="prod"></card-list>
                </div>
                <div class="list-card-empty" v-for="item of 20" :key="`key_${item}`"></div>
            </div>
        </el-card>

        <div class="pagination">
            <md-page :page="page" :total="total" :pageSize="pageSize" @pagecallback="pageChanged"></md-page>
        </div>
    </div>
</template>

<script>
import { ProductService, TodaySearchService, CompService } from "@/service";

import CardList from "@/components/card-list.vue";
export default{
    components: { CardList },
    data() {
        return {
            productDetail: {},
            customerList: [],
            prods: [],
            page: 1,
            pageSize: 30,
            total: 0,
            loading: false,
        }
    },
    mounted() {
        this.getProDetail();
    },
    methods: {
        async getProDetail() {
            const res = await ProductService.getInfo(this.$route.params.id);
            if (res) {
                this.productDetail = res;
                this.getStaffcustomerlist();
                this.loadProdList();
            }
        },
        async getStaffcustomerlist() {
            const res = await CompService.GetPublicUsers(this.productDetail.CompID);
            if (res) {
                this.customerList = res || [];
            }
        },

        pageChanged(param) {
            this.page = param.page;
            this.loadProdList();
        },
        async loadProdList() {
            //加载产品列表
            this.loading = true;
            this.prods = [];
            TodaySearchService.prodSearch({
                page: this.page,
                pageSize: this.pageSize,
                keyword: this.productDetail.ProdName,
            }).then(res => {
                this.prods = res.data.list.map(item => {
                    let newItem = {};
                    Object.keys(item).forEach(v => {
                        newItem[v.slice(0, 1).toUpperCase() + v.slice(1)] = item[v];
                    })
                    newItem.DirID = this.dirId;
                    newItem.ProdID = newItem.ProdId;
                    return newItem;
                });
                this.total = res.data.count || 0;
                this.loading = false;
            });
        },
    },
}
</script>

<style lang="less" scoped>

.prod-list-block {
  min-width: 150px;
  max-width: 180px;
  margin: 0 5px 10px 5px;
  flex: 1;
  border: 1px solid #d6d6d6;
  position: relative;
  &>.list-card{
    margin: 0;
    position: initial;
    height: 100%;
    border: 0 none;
    min-width: 100%;
  }
}
    .exception-view{
        width: 100%;
        min-height: 100vh;
        background-color: #F5F5F5;
        position: relative;
        .detail-view{
            width: 100%;
            background-color: #ffffff;
            padding: 12px 0;
            margin-bottom: 18px;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
        }
        .recommed-view{
            display: flex;
            flex-wrap: wrap;
        }
        .pagination{
            text-align: center;
            margin: auto;
            position: fixed;
            left: 0;
            bottom: 0;
            width: 100%;
            background: #ffffff;
            box-shadow: 0 -2px 12px 0 rgba(0,0,0,0.1);
        }
        /deep/ .el-card{
            margin: 0 auto;
            width: 1100px;
        }
        /deep/ .el-descriptions{
            margin: 0 auto;
            width: 1100px;
        }
        /deep/ .el-descriptions__extra{
            color: #00000073;
        }
        /deep/ .el-descriptions__title{
            color: #000000d9;
            font-size: 20px;
        }
    }
</style>